module.exports = __webpack_public_path__ + "static/media/prototype.651d98dc.png";